import ProductHistoryCompany from './ProductHistoryCompany';

export default class ProductHistoryCompanyChange {
	previous: ProductHistoryCompany | null;

	current: ProductHistoryCompany | null;

	constructor(previous: ProductHistoryCompany | null, current: ProductHistoryCompany | null) {
		this.previous = previous;
		this.current = current;
	}
}
